export default __webpack_public_path__ + "static/media/apeeswaplogo.687243d5.png";